<template>
    <table-search :fields="form" v-bind="$attrs"
                  no-search-btn disable-pop
                  @change="whenSearchChange"></table-search>
</template>

<script>
import TableSearch from "@/components/common/inputs/table-search/TableSearch.vue";

export default {
    name: "QgFilterBuilder",
    components: {TableSearch},
    props: {
        config: [String, Object],
    },
    data() {
        return {
            configuration: {}
        }
    },
    computed: {
        form() {
            let form = this.configuration.form;
            if (form) {
                let i18n = this.configuration.i18n;
                let locale = this.$i18n.locale();
                let trans = i18n[locale];
                if (trans) {
                    for (let f of form) {
                        f.label = trans[f.key];
                    }
                }
                return form;
            } else {
                return [];
            }
        },
    },
    watch: {
        config: {
            handler() {
                this.init();
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        init() {
            if (this.config) {
                if (typeof this.config === 'string') {
                    this.configuration = JSON.parse(this.config);
                } else {
                    this.configuration = this.config;
                }
            } else {

            }
        },
        whenSearchChange(form) {
            this.$emit('change', form);
        },
    }
}
</script>

<style scoped>

</style>
